import { ArrowRightIcon } from '@grupoboticario/flora-react-icons';

import { CTA_SHIPPING_MODEL_CONST, type ShippingModelCtaProps } from './ShippingModelCta.d';
import { Button } from './ShippingModelCta.styles';

const ShippingModelCta = ({ buttonLabel, disabled, onClick }: ShippingModelCtaProps) => (
  <>
    <Button.Wrapper>
      <Button.Cta
        data-testid={CTA_SHIPPING_MODEL_CONST.TEST_ID}
        disabled={disabled}
        onClick={onClick}
        radius="square"
        stretch
      >
        {buttonLabel} <ArrowRightIcon size={12} />
      </Button.Cta>
    </Button.Wrapper>
    <Button.Space />
  </>
);

export default ShippingModelCta;
